import { forwardRef, useContext, useEffect, useImperativeHandle } from "react";
import { DataTable } from "primereact/datatable";
import { useAPIGetCustomerVoucher } from "../api/api-get-customer-voucher-selector";
import { Column } from "primereact/column";
import CustomerVoucherSelectorFilter from "./customer-voucher-selector-filter";
import { Paginator } from "primereact/paginator";
import { genTemplateBodyDate, genTemplateBodyNumber, genTemplateBodyText } from "../../../../components/utils/TableTemplateBodyGenerator";

const CustomerVoucherSelectorList = forwardRef((props, ref) => {
  const { onConfirm, onHide, visible, title, additionalFilter, multiple } =
    props;

  const {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
    listSelected,
    setListSelected,
  } = useAPIGetCustomerVoucher({ additionalFilter });

  useImperativeHandle(ref, () => ({
    handleOnUpdateViewRow: (row) => {
      handleOnUpdateViewRow(row);
    },
    handleOnDeleteViewRow: (row) => {
      handleOnDeleteViewRow(row);
    },
    getSelectedData: () => {
      return listSelected;
    },
  }));

  // use effect section

  useEffect(() => {
    if (visible) {
      setListSelected([]);
      fetchListData({ page: paging.page, take: paging.take });
    }
  }, [visible]);
  //  custom ui section

  // PART_TEMPLATE_BODY_GENERATOR
  const NameBodyTemplate = (row) => genTemplateBodyText({ row, field: 'name' });
  const AmountBodyTemplate = (row) => genTemplateBodyNumber({ row, field: 'amount' });
  const ExpiredDateBodyTemplate = (row) => genTemplateBodyDate({ row, field: 'expired_date' });

  return (
    <div className="col-start-start w-full gap-4">
      {/* filter section */}
      <CustomerVoucherSelectorFilter
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        onClickRefresh={handleOnClickRefresh}
      />

      {/* table section */}
      <div className="col-start-start w-full gap-2">
        <DataTable
          dataKey="id"
          onSelectionChange={(e) => setListSelected(e.value)}
          selection={listSelected}
          className="w-100"
          loading={loading}
          showGridlines
          stripedRows
          value={listData}
        >
          <Column
            key=""
            selectionMode={multiple ? "multiple" : "single"}
            headerStyle={{ width: "3rem" }}
          ></Column>

          <Column
            field="no"
            header="#"
            align="center"
            className="text-center"
            headerClassName="w-[4rem]"
            alignHeader={"center"}
          />
          {/*PART_TEMPLATE_BODY_RENDER*/}
          <Column header='Name' field="name" body={NameBodyTemplate} />
          <Column header='Amount' field="amount" body={AmountBodyTemplate} />
          <Column header='Expired Date' field="expired_date" body={ExpiredDateBodyTemplate} />
        </DataTable>
        <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          template={{ layout: "PrevPageLink CurrentPageReport NextPageLink" }}
          onPageChange={handleOnPage}
          pt={{
            prevPageButton: {
              className:
                "bg-red-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
            },
            nextPageButton: {
              className:
                "bg-red-100 !m-0 !max-w-[22px] !w-[22px] !min-w-[22px] max-h-[22px]",
            },
            current: {
              className: "bg-red-100 !m-0 max-h-[22px] text-sm",
            },
          }}
        />
      </div>
    </div>
  );
});

export default CustomerVoucherSelectorList;
